var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66667 2L14 2M14 2L14 7.33333M14 2L7.33333 8.66667",
    stroke: "#748AA1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00065 2.66675V2.66675C5.69111 2.66675 5.53634 2.66675 5.40585 2.67816C3.95551 2.80505 2.80562 3.95494 2.67873 5.40528C2.66732 5.53577 2.66732 5.69054 2.66732 6.00008L2.66732 8.00008C2.66732 10.1862 2.66732 11.2793 3.20986 12.0541C3.41059 12.3408 3.65992 12.5901 3.94659 12.7909C4.72142 13.3334 5.8145 13.3334 8.00065 13.3334L10.0006 13.3334C10.3102 13.3334 10.465 13.3334 10.5955 13.322C12.0458 13.1951 13.1957 12.0452 13.3226 10.5949C13.334 10.4644 13.334 10.3096 13.334 10.0001V10.0001",
    stroke: "#748AA1",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.5c0dc17b5c9d4c2622329f4ec6c5af3e.svg";
export { ForwardRef as ReactComponent };